/**
 * leaving `staging` as legacy for now, but we should consider removing it
 */
export const enabledBugsnagReleaseStages = ["production", "staging", "stage:top", "stage:dev", "stage:ovh"];
